import moment from "moment";
import _ from "lodash";

import { filterRequestsByRangeDate, getRequestByStatus } from "../../utils";

interface CalculateItem {
  title: string;
  requests: Array<any>;
  fieldsWantToTake: Array<Array<string>>;
}

interface CalculateFilterItem {
  field: string;
  value: string | Array<moment.Moment> | null;
}

interface Calculate {
  charts: Array<"column" | "pie">;
  items: Array<CalculateItem>;
  filters?: Array<CalculateFilterItem>;
}

const getPercentText = (count: number, total: number): string => {
  if (count === 0) return `0%`;
  if (count === total) return `100%`;
  return `${((count / total) * 100).toFixed(2)}%`;
};

const calculateFilters = (
  requests: Array<any>,
  filters: CalculateFilterItem[]
) => {
  let filteredItemsResult = requests;
  filters.forEach(({ field, value }) => {
    if (value instanceof Array) {
      const rangeDate = value as [moment.Moment, moment.Moment];
      filteredItemsResult = filterRequestsByRangeDate(requests, rangeDate);
    }
  });
  return filteredItemsResult;
};

const getFieldsWantToTake = (
  requests: Array<any>,
  fieldsWantToTake: Array<Array<string>>
) => {
  const result: Array<any> = [];
  fieldsWantToTake.forEach((fields) => {
    result.push(getRequestByStatus(requests, fields));
  });
  return result;
};

const mapColumnChartValues = (items: CalculateItem[], response: Array<any>) => {
  return items.map((item, idx) => {
    const totalRequestDepartment = response[idx].reduce(
      (total: number, current: any) => (total += current.length),
      0
    );
    const mappedColumnChart = response[idx].map((item: any) => [
      item.length,
      getPercentText(item.length, totalRequestDepartment),
    ]);
    return [item.title, ..._.flattenDeep(mappedColumnChart)];
  });
};
const mapPieChartValues = (items: CalculateItem[], response: any) => {
  return items.map((item, idx) => [item.title, response[idx].length]);
};

export const calculateStatistic = (args: Calculate) => {
  const { charts, items, filters } = args;

  const response = items.reduce(
    (acc: any, current) => {
      const { requests, fieldsWantToTake } = current;
      const filteredItems = filters
        ? calculateFilters(requests, filters)
        : requests;
      const fieldWantToTakes = getFieldsWantToTake(
        filteredItems,
        fieldsWantToTake
      );
      return {
        beforeTake: [...acc.beforeTake, filteredItems],
        afterTake: [...acc.afterTake, fieldWantToTakes],
      };
    },
    { beforeTake: [], afterTake: [] }
  );

  return charts.reduce((result: any, current: "column" | "pie") => {
    if (current === "column") {
      result[current] = mapColumnChartValues(items, response.afterTake);
    }
    if (current === "pie") {
      result[current] = mapPieChartValues(items, response.beforeTake);
    }
    return result;
  }, {});
};
